import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let scriptPromise = null;

function loadScript(siteKey) {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (typeof window === "undefined") return resolve(null);
    if (window.grecaptcha) return resolve(window.grecaptcha);
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.grecaptcha);
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export function useRecaptcha() {
  const [siteKey, setSiteKey] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/config").then(({ data }) => {
      const k = (data?.recaptcha_site_key || "").trim();
      setSiteKey(k);
      if (!k) { setReady(true); return; }
      loadScript(k).then((grc) => {
        if (grc?.ready) grc.ready(() => setReady(true));
        else setReady(true);
      }).catch(() => setReady(true));
    }).catch(() => setReady(true));
  }, []);

  const execute = async (action = "enquiry") => {
    if (!siteKey) return "";  // dev mode: no key configured
    if (!window.grecaptcha) return "";
    try {
      return await window.grecaptcha.execute(siteKey, { action });
    } catch { return ""; }
  };

  return { siteKey, ready, execute };
}
